import script from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"

import "./ImageCropper.vue?vue&type=style&index=0&id=3770db6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3770db6a"]])

export default __exports__